.container {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressBar {
  width: 100%;
  height: 16px;
  margin-left: 16px;
  margin-right: 16px;
}

.label {
  min-width: 35px;
}
